<template>
  <div id="app">
    <router-view></router-view>

  </div>
</template>

<script>
export default {
  name: 'app',
};
</script>

<style lang="scss">
  // Import font
  @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,300i,400,400i');

  // Modify bulma
  @import '~bulma/sass/utilities/initial-variables';

  $family-sans-serif: "Source Sans Pro", Helvetica, sans-serif;
  $body-background: #242629;

  // Import bulma globally
  @import '~bulma';

  // Import flags
  @import "~flag-icon-css/css/flag-icon.min.css"
</style>

<style lang="less">
  // Import Selectize globally
  @import './assets/selectize.less';
</style>

<style lang="scss">
  // Bulma
  @import '~bulma/sass/utilities/variables';
  @import '~bulma/sass/utilities/mixins';

  .selectize-dropdown, .selectize-input, .selectize-input input, .delete-filters {
    @include mobile() {
      font-size: 10px;
    	line-height: 14px;
    }
  }

  // Font Awesome
  $fa-font-path: "~font-awesome/fonts";
  @import "~font-awesome/scss/font-awesome.scss";

</style>



// WEBPACK FOOTER //
// App.vue?38ada0a8